/**
 * תווית חלוקה + כמות מארזים לפי סניף.
 * @returns {{ show: boolean, label: string|null, packages: number|null, needsFresh: boolean }}
 */
export function getDistributionBadgeState(product, storeId) {
  if (!product) return { show: false, label: null, packages: null, needsFresh: false };

  const distByStore = product.distribution_by_store ?? product.distributionByStore;
  const storeKey = storeId ? String(storeId) : null;
  const entry =
    storeKey && distByStore && typeof distByStore === "object" ? distByStore[storeKey] : null;
  const storeActive = !!(entry?.until && new Date(entry.until) > new Date());
  const hasAnyStoreDist =
    !!distByStore && typeof distByStore === "object" && Object.keys(distByStore).length > 0;
  const globalActive = !!(product.is_distribution_product || product.isDistributionProduct);

  let packages = null;
  if (storeActive) {
    const n = Number(entry.packages);
    if (Number.isFinite(n) && n > 0) packages = n;
  } else if (globalActive && !hasAnyStoreDist) {
    const n = Number(product.distribution_packages);
    if (Number.isFinite(n) && n > 0) packages = n;
  }

  // רק בתוך 7 הימים (until) — כמות מארזים שפג תוקפה לא מציגה תווית
  const show = storeActive || (globalActive && !hasAnyStoreDist);

  const needsFresh =
    !!storeKey &&
    globalActive &&
    !storeActive &&
    !hasAnyStoreDist &&
    packages == null;

  const label = !show
    ? null
    : packages != null
      ? `חלוקה · ${packages} מארזים`
      : "חלוקה";

  return { show, label, packages, needsFresh };
}

/** מיזוג מפת distribution_by_store טרייה לתוך state קיים */
export function getDistributionBadgeStateWithFreshMap(product, storeId, freshDistByStore) {
  if (!freshDistByStore) return getDistributionBadgeState(product, storeId);
  return getDistributionBadgeState(
    {
      ...product,
      distribution_by_store: freshDistByStore,
    },
    storeId
  );
}
